import { cn } from "@/lib/utils";

export const PORTAL_SUB_NAV_BAR_CLASS = "w-full border-b bg-muted/30";

export const PORTAL_SUB_NAV_ROW_CLASS =
  "flex w-full min-w-0 items-center gap-1 overflow-x-auto whitespace-nowrap px-4 py-2 md:px-6";

export function portalSubNavTabClassName(active: boolean): string {
  return cn(
    "shrink-0 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
    active
      ? "bg-secondary-selected text-secondary-foreground"
      : "text-muted-foreground hover:bg-muted hover:text-foreground",
  );
}

/** TabsList styling for setup / question-configuration pages (matches PortalSubNav). */
export const SETUP_TABS_LIST_CLASS =
  "inline-flex h-auto min-w-0 flex-1 items-center gap-1 overflow-x-auto whitespace-nowrap bg-transparent p-0 rounded-none shadow-none";

/** TabsTrigger styling for setup / question-configuration pages (matches PortalSubNav). */
export const SETUP_TAB_TRIGGER_CLASS = cn(
  "shrink-0 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
  "text-muted-foreground hover:bg-muted hover:text-foreground",
  "h-auto flex-none border-transparent",
  "data-[state=active]:bg-secondary-selected data-[state=active]:text-secondary-foreground",
  "data-[state=active]:shadow-none",
);

/** @deprecated Use SETUP_TAB_TRIGGER_CLASS */
export const SETUP_ACTIVE_TAB_CLASS = SETUP_TAB_TRIGGER_CLASS;
